module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Light.woff2?4e2e86733ef877fed3bfd4a109fdd60c";